import * as React from 'react';
import { QueryClient, QueryClientProvider, QueryFunction } from 'react-query';
import API_2_0 from './api_2_0';

/**
 * This default query function allows us to use the `useQuery` hook with only the API route
 * Example:
 *    const { data, isLoading, error } = useQuery('guides/123');
 */
const defaultQueryFn: QueryFunction = ({ queryKey }) => {
   const endpoint = queryKey[0];
   return new API_2_0(endpoint, {
      method: 'GET',
   }).send();
};

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         queryFn: defaultQueryFn,
      },
   },
});

export function initializeReactQuery(component: React.ReactElement): React.ReactElement {
   return <QueryClientProvider client={queryClient}>{component}</QueryClientProvider>;
}
